import { auth } from "../Firebase/firebase";
import router from "../router/router";

export const baseurl = `https://smart-menu.netlify.app`;
export const routeGaurd = (to, form, next) => {
  const requiresAuth = to.matched.some((x) =>
    x.meta.requiresAuth ? x.meta.requiresAuth.status : false
  );

  if (requiresAuth && (!auth.currentUser||auth.currentUser.isAnonymous===true)) {
    next(to.meta.requiresAuth.nextLink);
  } else {
    next();
  }
}

;
